import { CircularProgress, type GridSize } from "@mui/material";
import { type FC, type FunctionComponent, type PropsWithChildren, type ReactNode } from "react";
import { FormattedNumber } from "react-intl";

import { ContentWrapper } from "../ContentWrapper";
import { IconWrapper, ItemWrapper, StyledGrid, SummaryContainer, SummaryItemContainer, SummaryNumber, SummaryText } from "./Summary.sc";

interface SummaryItemProps {
    icon: ReactNode;
    count?: number;
    text: ReactNode;
    size?: GridSize;
}

interface SummaryProps {
    items: SummaryItemProps[];
    title?: string;
    variant?: "default" | "dashboard";
}

const SummaryItem: FC<PropsWithChildren<SummaryItemProps>> = ({ icon, count, text, size }) => {
    return (
        <SummaryItemContainer size={size}>
            <ItemWrapper>
                <IconWrapper>{icon}</IconWrapper>
                <SummaryNumber color="primary" variant="h3">
                    {count === undefined ? <CircularProgress /> : <FormattedNumber value={count} maximumFractionDigits={2} />}
                </SummaryNumber>
            </ItemWrapper>
            <SummaryText>{text}</SummaryText>
        </SummaryItemContainer>
    );
};

const Summary: FunctionComponent<PropsWithChildren<SummaryProps>> = ({ items, title, variant }) => {
    const size = Math.round(12 / items.length) as GridSize;
    return (
        <SummaryContainer>
            <ContentWrapper title={title} titleStyle={variant}>
                <StyledGrid container $variant={variant}>
                    {items.map((item, index) => (
                        <SummaryItem key={index} icon={item.icon} count={item.count} text={item.text} size={size} />
                    ))}
                </StyledGrid>
            </ContentWrapper>
        </SummaryContainer>
    );
};

export default Summary;
